import React, { Component, useState, useRef } from "react";

export class AddCommentPrompt extends Component {
    state= {
      compact: true,
      text: "",
      colourcode: "green",
    };
  
    // for TipContainer
    componentDidUpdate(nextProps, nextState) {
      const { onUpdate } = this.props;
  
      if (onUpdate && this.state.compact !== nextState.compact) {
        onUpdate();
      }
    }
  
    render() {
        const { onConfirm, onOpen } = this.props;
        const { compact, text, colourcode: colourcode } = this.state;
  
        return (
            <div className="Tip">
                {compact ? (
                    <div
                        style={{backgroundColor: "#f5f5f5", border: "1px solid #999", padding: "3px 6px", cursor: "pointer"}}
                        onClick={() => {
                            onOpen();
                            this.setState({ compact: false });
                        }}>
                        <i className="far fa-comment-alt"></i> Add annotation
                    </div>
                ) : (
                    <div className="Tip__card">
                        <form
                            onSubmit={(event) => {
                                event.preventDefault();
                                onConfirm({ text, colourcode: colourcode });
                            }}>

                            <div style={{marginBottom: "6px",}}>
                                <h6>Annotation</h6>
                            </div>

                            <div>
                                <textarea
                                    style={{fontSize: "13px", height: "65px", outline: "none"}}
                                    placeholder="Your annotation"
                                    value={text}
                                    onChange={(event) =>
                                        this.setState({ text: event.target.value })
                                    }
                                    ref={(node) => {
                                        if (node) {
                                            node.focus();
                                        }
                                    }}
                                />
                            </div>

                            <div style={{ display: "flex", flexDirection: "row", marginTop: "10px" }}>
                                    <div style={{marginRight: "6px"}}>Color:</div>
                                <div>
                                    <span onClick={(event) => { this.setState({ colourcode: "green" }) }}
                                        className={`dot dot-green ${colourcode == "green" ? "selected-dot-green" : ""}`}></span>

                                    <span onClick={(event) => { this.setState({ colourcode: "yellow" }) }}
                                        className={`dot dot-yellow ${colourcode == "yellow" ? "selected-dot-yellow" : ""}`}></span>

                                    <span onClick={(event) => { this.setState({ colourcode: "red" }) }}
                                        className={`dot dot-red ${colourcode == "red" ? "selected-dot-red" : ""}`}></span>

                                    <span onClick={(event) => { this.setState({ colourcode: "blue" }) }}
                                        className={`dot dot-blue ${colourcode == "blue" ? "selected-dot-blue" : ""}`}></span> 
                                </div>

                            </div>


                                <div style={{ display: "flex", flexDirection: "row", marginTop: "10px", justifyContent: "center" }}>
                                    <input type="submit" className="btn btn-outline-dark my-2 my-sm-0" style={{ fontSize: "0.9rem" }} value="Save" />
                            </div>
                        
                        </form>
                    </div>
              

                )}
            </div>
        );
    }
}
  
  export default AddCommentPrompt;
  